// extracted by mini-css-extract-plugin
export default {"root":"ClientAddInvestorPage_root__cKfhU","buttons":"ClientAddInvestorPage_buttons__UfIEM"};